import React from 'react';
import { Control, Controller, get } from 'react-hook-form';
import { MenuItem, TextField, TextFieldProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface BooleanSelectOptions {
  yes: string;
  no: string;
}
type CustomTextFieldProps = TextFieldProps & {
  errors?: any;
  control: Control<any>;
  helperText?: string;
  name: string;
  enableBoth?: boolean;
  options?: BooleanSelectOptions;
};

export const BooleanSelectInput: React.FC<CustomTextFieldProps> = ({
  errors,
  name,
  control,
  helperText,
  enableBoth,
  options,
  ...rest
}) => {
  const { t } = useTranslation();
  const error = get(errors, name);
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={null}
      render={({ field: { onChange, onBlur, value } }) => (
        <TextField
          error={Boolean(error)}
          helperText={error?.message || helperText}
          fullWidth
          select
          variant="outlined"
          onBlur={onBlur}
          onChange={(e) => {
            if (e.target.value === 'true') return onChange(true);
            if (e.target.value === 'false') return onChange(false);
            if (e.target.value === 'null') return onChange(null);
            onChange(e.target.value === 'true');
          }}
          value={value === null ? 'null' : value.toString()}
          {...rest}
        >
          <MenuItem value="true">
            {options?.yes || String(t('global.yes'))}
          </MenuItem>
          <MenuItem value="false">
            {options?.no || String(t('global.no'))}
          </MenuItem>
          {enableBoth && (
            <MenuItem value="null">{String(t('global.yesAndNo'))}</MenuItem>
          )}
        </TextField>
      )}
    />
  );
};
